import * as React from 'react';
import { LineChart, YAxis, XAxis, CartesianAxis, Tooltip, TooltipProps, Legend, Line, CartesianGrid, Bar, ComposedChart, ResponsiveContainer } from 'recharts'
import { Box, Dialog, DialogContent, DialogContentText, DialogTitle, IconButton, Paper, Theme } from '@mui/material';
import {
    InfoButton,
    CloseButton,
} from '../resources'
import  makeStyles  from '@mui/styles/makeStyles';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import moment, { weekdaysMin } from 'moment';

const useStyles = makeStyles ((theme: Theme) => ({
    paper: {            
            borderRadius: 20,
            border: '3px solid #404040',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
            marginBottom: 39,
            marginLeft: 5,
            marginRight: 5,
    },
    chartTitle: {        
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "24px",
        marginLeft: "35px",   
        fontFamily: "Poppins", 
        color: "#404040",
    },
    chart: {
        width: "100%",
        disaply: "flex",
        justifyContent: "center"
    },
    text: {
        fontFamily: "Poppins",
        fontSize: "0.875rem",
        fontWeight: 400,        
        margin: 5,
    },

    timeTooltipText: {
        fontFamily: "Poppins",
        fontSize: "0.875rem",
        fontWeight: 400,   
        margin: 3,  
        marginBottom: 0,     
    },

    dialogTitle: {
		display: "flex",        
        color: "#404040",
        width: "100%",
        alignItems: "center",
        textAlign: "center",
        justifyContent: "center",         
        paddingTop: "15px",
        paddingBottom: "10px",        
        paddingLeft: "4px",
        padding: 0, 		
        fontSize: "16px", 
        fontWeight: 700,         
        flex: 1,
        whiteSpace: "normal",
        textOverflow: "ellipsis" 		 
	},   
}))

export default function BasicLineChart({volumesByDay, selectedYear, isMonthlySelection, totalTimeSpentPerDate, selectDateRange, activityVolumeByDay, selectedProgram, selectedActivity, setSelectedActivity, trainings, selectedInterval}) {
    console.log("totalTimeSpentPerDate in chart component", totalTimeSpentPerDate);    
    const itemWidth = 100;
    const classes = useStyles()            
    const [startIndex, setStartIndex] = React.useState(0);
    const [visibleMonths, setVisibleMonths] = React.useState([]);
    const [visibleWeeks, setVisibleWeeks] = React.useState([]);
    const [visibleDays, setVisibleDays] = React.useState([]);    
    const [dailyData, setDailyData] = React.useState([]);
    const [weeklyData, setWeeklyData] = React.useState([]);
    const [monthlyData, setMonthlyData] = React.useState([]);
    const [renderKey, setRenderKey] = React.useState(0);
    const [openVolumeDialog, setOpenVolumeDialog]= React.useState(false);
    const [openTimeDialog, setOpenTimeDialog]= React.useState(false);    
    const {t, i18n} = useTranslation();            
    const [containerWidth, setContainerWidth] = React.useState(0);
    const volumeChartRef = React.useRef<HTMLDivElement>(null);
    const timeChartRef = React.useRef<HTMLDivElement>(null);        
    console.log("selectedDateRange in chart component", selectDateRange)
    console.log("volumesByDay in chart component", Array.from(volumesByDay.entries()));
    console.log("trainings in chart component", trainings)

    moment.locale(i18n.language);       
    useEffect(() => {
        setSelectedActivity(null);
    },[selectedProgram, setSelectedActivity])

    useEffect(() => {
        setRenderKey(prev => prev + 1); // Force re-render when selectedInterval changes
    }, [selectedInterval]);
let formattedStartRange = new Date();
let formattedEndRange = new Date();
if(selectDateRange && selectDateRange.startDate && selectDateRange.endDate) {
    const startRange = selectDateRange.startDate
    const endRange = selectDateRange.endDate
    formattedStartRange = new Date(startRange);
    formattedEndRange = new Date(endRange);
    
}

const handleOpenVolumeDialog = () => setOpenVolumeDialog(true);
const handleCloseVolumeDialog = () => setOpenVolumeDialog(false);

const handleOpenTimeDialog = () => setOpenTimeDialog(true);
const handleCloseTimeDialog = () => setOpenTimeDialog(false);

let chartData = null;
const timeChartData = []

totalTimeSpentPerDate.forEach((visitTypeMap, visitType) => {
    visitTypeMap.forEach((timeValue, dateKey) => {           
        timeChartData.push({
            date: dateKey,
            gymTime:  (visitType === 1 || visitType === 3 ) ? timeValue : 0,
            homeTime: visitType === 4 ? timeValue : 0,
        })        
    })
})

console.log("selected program in chart component", selectedProgram)

const calculateDailyTimes = (timeChartData, selectedYear) => {
    const dailyTimes = new Map();

    timeChartData.forEach(({ date, gymTime, homeTime }) => {       
        const parsedDate = new Date(date);
        if (isNaN(parsedDate.getTime()) || parsedDate.getFullYear() !== selectedYear) return;

        dailyTimes.set(date, { gymTime: (dailyTimes.get(date)?.gymTime || 0) + gymTime, homeTime: (dailyTimes.get(date)?.homeTime || 0) + homeTime });
    });

    return dailyTimes;
};

const calculateDailyActivityVolumes = (activityVolumesMap, selectedYear) => {
    const dailyActivityVolumes = new Map();

    activityVolumesMap.forEach((activityMap, activityName) => {
        const activityDailyMap = new Map();

        activityMap.forEach((volume, date) => {
            const dateParts = date.split('.');
            if (dateParts.length !== 3) return;

            const parsedDate = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);
            if (isNaN(parsedDate.getTime()) || parsedDate.getFullYear() !== selectedYear) return;

            activityDailyMap.set(date, (activityDailyMap.get(date) || 0) + volume);
        });

        dailyActivityVolumes.set(activityName, activityDailyMap);
    });

    return dailyActivityVolumes;
};

const calculateWeeklyTimes = (timeChartData, selectedYear) => {
    const weeklyTimes = new Map();

    for (let week = 1; week <= 52; week++) {
        const weekKey = `${selectedYear}-W${String(week).padStart(2, '0')}`;
        weeklyTimes.set(weekKey, { gymTime: 0, homeTime: 0 });
    }

    timeChartData.forEach(({ date, gymTime, homeTime }) => {  

        const parsedDate = new Date(date);
        if (isNaN(parsedDate.getTime())) {
            console.error("Invalid date:", date);
            return;
        }

        if (parsedDate.getFullYear() !== selectedYear) return;

        const yearStart = new Date(parsedDate.getFullYear(), 0, 1);
        const weekNumber = Math.min(
            Math.floor((parsedDate.getTime() - yearStart.getTime()) / (7 * 24 * 60 * 60 * 1000)) + 1,
            52
        );
        const weekKey = `${parsedDate.getFullYear()}-W${String(weekNumber).padStart(2, '0')}`;

        const current = weeklyTimes.get(weekKey);
        weeklyTimes.set(weekKey, {
            gymTime: current.gymTime + gymTime,
            homeTime: current.homeTime + homeTime,
        });
    });

    const sortedWeeklyTimes = new Map([...weeklyTimes.entries()].sort(([a], [b]) => {
        const [yearA, weekA] = a.split('-W').map(Number);
        const [yearB, weekB] = b.split('-W').map(Number);
        return yearA !== yearB ? yearA - yearB : weekA - weekB;
    }));

    return sortedWeeklyTimes;
};

const calculateWeeklyVolumes = (volumesByDay, selectedYear) => {
    const weeklyVolumes = new Map();

    volumesByDay.forEach((volume, date) => {      

        const parsedDate = new Date(date);
        if (isNaN(parsedDate.getTime()) || parsedDate.getFullYear() !== selectedYear) return;

        const weekNumber = getWeekNumber(parsedDate);
        const weekKey = `${parsedDate.getFullYear()}-W${String(weekNumber).padStart(2, '0')}`;
        weeklyVolumes.set(weekKey, (weeklyVolumes.get(weekKey) || 0) + volume);
    });

    return new Map([...weeklyVolumes.entries()]);
};


const getWeekNumber = (date) => {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
};

const calculateWeeklyActivityVolumes = (activityVolumesByDay, selectedYear) => {
    const weeklyActivityVolumes = new Map();

    activityVolumesByDay.forEach((activityMap, activityName) => {
        const weeklyVolumes = new Map();

        activityMap.forEach((volume, date) => {     
            const parsedDate = new Date(date);
            if (isNaN(parsedDate.getTime()) || parsedDate.getFullYear() !== selectedYear) return;

            const weekNumber = getWeekNumber(parsedDate);
            const weekKey = `${parsedDate.getFullYear()}-W${String(weekNumber).padStart(2, '0')}`;
            weeklyVolumes.set(weekKey, (weeklyVolumes.get(weekKey) || 0) + volume);
        });

        weeklyActivityVolumes.set(activityName, weeklyVolumes);
    });

    return weeklyActivityVolumes;
};

const parseDate = (dateString) => {
    const [day, month, year] = dateString.split('.');
    return new Date(Date.UTC(year, month - 1, day));
}

const calculateMonthlyVolumes = (volumesByDay, selectedYear) => {
    const monthlyVolumes = new Map();

    for (let month = 1; month <= 12; month++) {
        const monthKey = `${selectedYear}-${String(month).padStart(2, '0')}`;
        monthlyVolumes.set(monthKey, 0);
    }

    volumesByDay.forEach((volume, date) => {
        const parsedDate = new Date(date);
        if (isNaN(parsedDate.getTime()) || parsedDate.getFullYear() !== selectedYear) return;

        const monthKey = `${parsedDate.getFullYear()}-${String(parsedDate.getMonth() + 1).padStart(2, '0')}`;
        monthlyVolumes.set(monthKey, (monthlyVolumes.get(monthKey) || 0) + volume);
    });

    return monthlyVolumes;
};

const calculateMonthlyActivityVolumes = (activityVolumeByDay, selectedYear) => {
    const monthlyActivityVolumes = new Map();
    
    for (let month = 1; month <= 12; month++) {
        const monthKey = `${selectedYear}-${String(month).padStart(2, '0')}`;
        monthlyActivityVolumes.set(monthKey, new Map());
    }

    activityVolumeByDay.forEach((dateVolumeMap, activity) => {
        dateVolumeMap.forEach((volume, date) => {
            const parsedDate = new Date(date);
            if (isNaN(parsedDate.getTime()) || parsedDate.getFullYear() !== selectedYear) return;

            const monthKey = `${parsedDate.getFullYear()}-${String(parsedDate.getMonth() + 1).padStart(2, '0')}`;
            const activityMap = monthlyActivityVolumes.get(monthKey);
            const currentVolume = activityMap.get(activity) || 0;
            activityMap.set(activity, currentVolume + volume);
        });
    });

    return monthlyActivityVolumes;
};

const calculateMonthlyTimes = (timeChartData, selectedYear) => {
    const monthlyTimes = new Map();

    for(let month = 1; month <= 12; month++) {
        const monthKey = `${selectedYear}-${String(month).padStart(2, '0')}`;
        monthlyTimes.set(monthKey, { gymTime: 0, homeTime: 0});
    }

    timeChartData.forEach(({ date, gymTime, homeTime }) => {
        const parsedDate = new Date(date);
        if (isNaN(parsedDate.getTime()) || parsedDate.getFullYear() !== selectedYear) return;

        const monthKey = `${parsedDate.getFullYear()}-${String(parsedDate.getMonth() + 1).padStart(2, '0')}`;
        const current = monthlyTimes.get(monthKey);
        monthlyTimes.set(monthKey, {
            gymTime: current.gymTime + gymTime,
            homeTime: current.homeTime + homeTime,
        });
    });

    return monthlyTimes;
};

const memoizedVolumesByDay = React.useMemo(() => volumesByDay, [volumesByDay]);
const memoizedActivityVolumeByDay = React.useMemo(() => activityVolumeByDay, [activityVolumeByDay]);
const memoizedTimeChartData = React.useMemo(() => timeChartData, [timeChartData]);
console.log('Memoized volumes by day:', memoizedVolumesByDay);
console.log('Memoized activity volume by day:', memoizedActivityVolumeByDay);


  const test = calculateWeeklyActivityVolumes(memoizedActivityVolumeByDay, selectedYear);
  console.log("test weekly activity calculation", test);

  const monthTest = calculateMonthlyActivityVolumes(memoizedActivityVolumeByDay, selectedYear);
  console.log("test monthly activity calculation", monthTest);
  const calculatedData = React.useMemo(() => {
    switch (selectedInterval) {
        case 'daily':
            return selectedActivity
            ? (memoizedActivityVolumeByDay.get(selectedActivity) || new Map())
            : memoizedVolumesByDay;
                case 'weekly':
            const weeklyCalc = selectedActivity ? calculateWeeklyActivityVolumes(memoizedActivityVolumeByDay, selectedYear).get(selectedActivity) || new Map() : calculateWeeklyVolumes(memoizedVolumesByDay, selectedYear);                        
            console.log("weeklyCalc:", weeklyCalc);
            return weeklyCalc;    
                    case 'monthly':
                        const monthlyCalc = selectedActivity 
                        ? (() => {
                            const monthActivityMap = calculateMonthlyActivityVolumes(memoizedActivityVolumeByDay, selectedYear);
                            const result = new Map();
                    
                            monthActivityMap.forEach((activityMap, monthKey) => {
                                const activityValue = activityMap.get(selectedActivity) || 0;
                                result.set(monthKey, activityValue);
                            });
                    
                            return result;
                        })()
                        : calculateMonthlyVolumes(memoizedVolumesByDay, selectedYear);
                    
                        console.log("Calculated Monthly Data:", Array.from(monthlyCalc.entries()));
                    return monthlyCalc;
            default:
            return new Map();
    }
}, [selectedInterval, selectedYear, selectedActivity, memoizedVolumesByDay, memoizedActivityVolumeByDay]);

  const calculateTimeData = React.useMemo(() => {
    switch (selectedInterval) {
      case 'daily':
        return calculateDailyTimes(memoizedTimeChartData, selectedYear);
      case 'weekly':
        return calculateWeeklyTimes(memoizedTimeChartData, selectedYear);
      case 'monthly':
        return calculateMonthlyTimes(memoizedTimeChartData, selectedYear);
      default:
        return new Map();
    }
  }, [selectedInterval, selectedYear, memoizedTimeChartData]);
  
  const memoizedCalculatedData = React.useMemo(() => calculatedData, [calculatedData]);
  const memoizedTimeData = React.useMemo(() => calculateTimeData, [calculateTimeData]);

console.log('Calculated data:', memoizedCalculatedData);
console.log('Time data:', memoizedTimeData);

//------------------------------------------------------------------------------

useEffect(() => {
    console.log("useEffect triggered! Selected Activity:", selectedActivity);
    const currentYear = selectedYear;
    let updated = false;

    console.log("memoizedActivityVolumeByDay:", memoizedActivityVolumeByDay);
    console.log("Selected activity data:", memoizedActivityVolumeByDay.get(selectedActivity));
    
    const months = Array.from({ length: 12 }, (_, i) => {
        const month = String(i + 1).padStart(2, '0');
        return `${selectedYear}-${month}`; // Ensuring consistent YYYY-MM format
    });
    
    const newMonthlyData = months.map(month => ({
        date: month,
        volume: memoizedCalculatedData.get(month) ?? 0 // Ensure default value
    }));

    if (newMonthlyData.length !== monthlyData.length || 
        newMonthlyData.some((d, i) => d.volume !== monthlyData[i]?.volume)) {
        setMonthlyData(newMonthlyData);
        console.log("New Monthly Data", newMonthlyData);
        updated = true;
    }
    
    const weeks = Array.from({ length: 52 }, (_, i) => {
        const week = String(i + 1).padStart(2, '0');
        return `${selectedYear}-W${week}`; // Ensuring consistent YYYY-W## format
    });
    
    const newWeeklyData = weeks.map(week => ({
        date: week,
        volume: memoizedCalculatedData.get(week) ?? 0 // Ensure default value
    }));

    if (newWeeklyData.length !== weeklyData.length || 
        newWeeklyData.some((d, i) => d.volume !== weeklyData[i]?.volume)) {
        setWeeklyData(newWeeklyData);
        console.log("New Weekly Data", newWeeklyData);
        updated = true;
    }

    const yearKeys = Array.from(memoizedCalculatedData.keys()).filter(key => 
        String(key).startsWith(selectedYear.toString()) // Match YYYY-MM-DD format
    );

    const sortedKeys = yearKeys
    .map(date => ({ original: date, parsed: new Date(date as string) })) // Directly use ISO dates
    .sort((a, b) => a.parsed.getTime() - b.parsed.getTime())
    .map(item => item.original);
    
    const newDailyData = sortedKeys.map(date => {
        const volume = selectedActivity
            ? (memoizedActivityVolumeByDay.get(selectedActivity)?.get(date) || 0)
            : (memoizedVolumesByDay.get(date) || 0);
    
        const timeData = memoizedTimeData.get(date) || { gymTime: 0, homeTime: 0 };
    
        return { date, volume, ...timeData };
    }).filter(item => item.volume > 0 || item.gymTime > 0 || item.homeTime > 0);

        if (JSON.stringify(newDailyData) !== JSON.stringify(dailyData)) {
            setDailyData(newDailyData);
            console.log('New daily data:', dailyData);
            updated = true;
        }

        if(!updated) return;

        console.log("Memoized Time Data Keys:", Array.from(memoizedTimeData.keys()));
console.log("Sorted Keys:", sortedKeys);

}, [selectedYear, memoizedCalculatedData, memoizedTimeData, memoizedVolumesByDay, selectedActivity, memoizedActivityVolumeByDay]);

const chartRef = React.useRef<HTMLDivElement | null>(null);

const findLast = (array, predicate) => {
    for(let i = array.length - 1; i >= 0; i--) {
        if(predicate(array[i])) return i;
    }
    return -1;
};

const sourceData = React.useMemo(() => {
    switch (selectedInterval) {
        case 'daily':
            return dailyData;
        case 'weekly':
            return weeklyData;
        case 'monthly':
            return monthlyData;
        default:
            return [];
    }
}, [dailyData, weeklyData, monthlyData, selectedInterval]);

useEffect(() => {
    if (sourceData.length === 0) return;
    
    const lastIndex = findLast(sourceData, item => item.volume > 0);

    if (lastIndex !== -1) {
        const sliceAmount = selectedInterval === 'daily' ? 3 : 4;
        
        let newIndex = Math.max(0, lastIndex - ((lastIndex + 1) % sliceAmount));

        setStartIndex(prevIndex => (prevIndex !== newIndex ? newIndex : prevIndex));
    }
}, [sourceData, selectedInterval]);

const displayedData = React.useMemo(() => {
    if (sourceData.length === 0) return [];

    let labelProperty = 'date';
    if (selectedInterval === 'weekly') labelProperty = 'week';
    if (selectedInterval === 'monthly') labelProperty = 'month';
        return sourceData.map(item => ({
            ...item,
            [labelProperty]: item.date,
    }));
    
   
}, [sourceData, selectedInterval, startIndex, selectedActivity]);

// const displayedTimeData = React.useMemo(() => {
//     if (displayedData.length === 0) return [];

//     return displayedData.map(({ date }) => {
//         const timeData = memoizedTimeData.get(date) || { gymTime: 0, homeTime: 0 };
//         return {
//             date,
//             ...timeData,
//             [selectedInterval === 'weekly' ? 'week' : 'date']: date,
//         };
//     });
// }, [displayedData, memoizedTimeData]);

const displayedTimeData = React.useMemo(() => {
    if (selectedInterval === 'daily') {
        // For daily, show all entries from memoizedTimeData
        return Array.from(memoizedTimeData.entries()).map(([date, { gymTime, homeTime }]) => ({
            date,
            gymTime,
            homeTime,
        }));        
    }
    

    // For weekly/monthly, match only the visible weeks/months
    return displayedData.map((item) => {
        const timeData = memoizedTimeData.get(item.date) || { gymTime: 0, homeTime: 0 };
        return {
            ...item,
            ...timeData,
            [selectedInterval === 'weekly' ? 'week' : 'month']: item.date,
        };
        
    });
}, [memoizedTimeData, displayedData, selectedInterval]);


  const dataLength = displayedData.length;  
  const chartsWidth = dataLength * itemWidth;  

  const isSyncingScroll = {volume: false, time: false};
  
    const handleScroll = (e) => {
        const scrollLeft = e.target.scrollLeft;
    
        if (e.target === volumeChartRef.current && timeChartRef.current) {
            timeChartRef.current.removeEventListener("scroll", handleScroll);
            timeChartRef.current.scrollLeft = scrollLeft;
            timeChartRef.current.addEventListener("scroll", handleScroll);
        }
    
        if (e.target === timeChartRef.current && volumeChartRef.current) {
            volumeChartRef.current.removeEventListener("scroll", handleScroll);
            volumeChartRef.current.scrollLeft = scrollLeft;
            volumeChartRef.current.addEventListener("scroll", handleScroll);
        }
    };
        
    useEffect(() => {
        if (volumeChartRef.current && timeChartRef.current) {
            volumeChartRef.current.addEventListener("scroll", handleScroll);
            timeChartRef.current.addEventListener("scroll", handleScroll);
        }
    
        return () => {
            volumeChartRef.current?.removeEventListener("scroll", handleScroll);
            timeChartRef.current?.removeEventListener("scroll", handleScroll);
        };
    }, []);
    
    useEffect(() => {
    if (timeChartRef.current && volumeChartRef.current) {
        const scrollPos = startIndex * itemWidth;
        volumeChartRef.current.scrollLeft = scrollPos;
        timeChartRef.current.scrollLeft = scrollPos;
    }
}, [startIndex]);


  useEffect(() => {
    console.log("Visible intervals:", { visibleMonths, visibleWeeks, visibleDays });
    console.log("Displayed data:", displayedData);
    console.log("Time data:", displayedTimeData);
  }, [visibleMonths, visibleWeeks, visibleDays, displayedData, displayedTimeData, selectedActivity]);

const reversedChartData = chartData ? [...chartData].reverse() : [];

const filterTimeChartData = timeChartData.filter(data => data.gymTime > 0 || data.homeTime > 0);

filterTimeChartData.sort((a, b) => {
    const dateA = moment(a.date, 'DD-MM-YYYY')
    const dateB = moment(b.date, 'DD-MM-YYYY')
    const dateComparison = dateA.diff(dateB)
    if(dateComparison !== 0){
        return dateComparison;
    } else {
        return a.time - b.time;
    }
})

const reversedTimeChartDate = [...filterTimeChartData].reverse()
console.log("Chart data", reversedChartData);

console.log("timeChartData",reversedTimeChartDate);

const CustomTimeTooltip: React.FC<TooltipProps<number, string>> = ({active, payload, label}) => {
    if(active && payload && payload.length) {
        let formattedLabel = label;

        if(selectedInterval === "weekly") {
            if(label.includes("-W")) {
                const weekNumber = label.split("-W")[1];
                formattedLabel = `${t('progress_page.weeks')} ${weekNumber}`;
            }
        } else if(selectedInterval === "monthly") {
            const monthNames = t('progress_page.months', { returnObjects: true });
            const [year, month] = label.split("-");
            formattedLabel = `${monthNames[parseInt(month) - 1]}`
        } else if(selectedInterval == 'daily') {
            const date = new Date(label);
            formattedLabel = date.toLocaleDateString();
        }
        console.log("tooltip payload", payload)
        const gymVisit = payload.find(item => item.name === t('common.gym_visit'))?.value ?? 0;
        const homeVisit = payload.find(item => item.name === t('common.home_workout'))?.value ?? 0;

        const formatTime = (minutes: number) => {
            if(minutes >= 60) {
                const hours = Math.floor(minutes / 60);
                const remainingMinutes = minutes % 60;
                return remainingMinutes > 0 ? `${hours} ${t('progress_page.hours')} ${remainingMinutes} ${t('progress_page.mins')}` : `${hours} ${t('progress_page.hours')}`;
            }
            return `${minutes} ${t('progress_page.mins')}`;
        }
        return (
            <div style={{
                backgroundColor: "#fff",
                borderRadius: "8px",
                border: "1px solid #404040",
                display: 'flex',
                flexDirection: 'column',
                marginBottom: 40,
                textAlign: 'left',          
                justifyContent: 'center',
            }}>
                <p className={classes.timeTooltipText} >{formattedLabel}</p>
                {gymVisit !== 0 && (
                <p className={classes.text} style={{marginTop: 0, marginBottom: 0, color: "#46A9DB"}}>{`${t('common.gym_visit')}: ${formatTime(gymVisit)}`}</p>
            )}
                {homeVisit !== 0 && (
                <p className={classes.text} style={{marginTop: 0, marginBottom: 0, color: "#F28986"}}>{`${t('common.home_workout')}: ${formatTime(homeVisit)}`}</p>
            )}
            </div>
        )
    }
    return null;
}

const CustomToolTip: React.FC<TooltipProps<number, string>> = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      let formattedLabel = label;
  
      if (selectedInterval === "weekly" && label) {
        if (label.includes("-W")) {
          const weekNumber = label.split("-W")[1];
          formattedLabel = `${t('progress_page.weeks')} ${weekNumber}`;
        }
      } else if (selectedInterval === "monthly" && label) {
        const monthNames = t('progress_page.months', { returnObjects: true });
        const [year, month] = label.split("-");
        formattedLabel = `${monthNames[parseInt(month) - 1]}`;
      } else if(selectedInterval === 'daily' && label) {
        const date = new Date(label);
        formattedLabel = date.toLocaleDateString();
      }
  
      return (
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            border: "1px solid #404040",
          }}
        >
          <p className={classes?.text} style={{ marginBottom: 0 }}>
            {formattedLabel}
          </p>
          <p className={classes?.text} style={{ marginTop: 0 }}>
            {`${t('progress_page.volume_chart')}: ${payload[0].value}`}
          </p>
        </div>
      );
    }
    return null;
  };

const textColor = (value, entry) => {
    return (
        <span style= {{color: '#404040', fontFamily: "Poppins", fontSize: "0.6875rem", fontWeight: 400}}>{value}</span>
    )
}

const CustomTick = ({ x, y, payload, selectedInterval }) => {
    const value = payload.value;
    let formattedValue = value;
    let boxPadding = 10;    
    if (selectedInterval === 'weekly') {
        const weekNumber = value.split('-W')[1];
        formattedValue = `${t('progress_page.weeks')} ${weekNumber}`;
    } else if (selectedInterval === 'monthly') {
        const monthNames = t('progress_page.shortend_months', { returnObjects: true });
        const [year, month] = value.split('-');
        formattedValue = `${monthNames[parseInt(month) - 1]}`;
        boxPadding = 20;
    }

    // For daily, return plain text without a box
    if (selectedInterval === 'daily') {
        try {
            const date = new Date(value)
            formattedValue = date.toLocaleDateString()
        } catch (error) {
            console.error("Error formatting date:", error)
        }
        return (
            <text
                x={x}
                y={y + 7} // Adjust position
                textAnchor="middle"
                fontFamily="Poppins"
                fontSize="0.75rem"
                fill="black"
            >
                {formattedValue}
            </text>
        );
    }    
    const textWidth = formattedValue.length * 7;    
    const boxWidth = textWidth + boxPadding;

    return (
        <g transform={`translate(${x},${y})`}>
            <rect
                x={-boxWidth / 2}
                y={-9}
                width={boxWidth}
                height={20}
                fill="rgba(15, 84, 134, 1)"
                rx={5} 
            />
            <text
                x={0}
                y={5}
                textAnchor="middle"
                fontFamily="Poppins"
                fontWeight= "500"
                fontSize="12px"
                fill="#FFFFFF"
            >
                {formattedValue}
            </text>
        </g>
    );
};

const hasRequiredTrainings = trainings.some(training => 
    training.visit_type === 1 || training.visit_type === 3
)
const hasChartData = volumesByDay && volumesByDay.size > 0
const hasTimeChartData = timeChartData && timeChartData.length > 0;

return (
    <div key={renderKey}>
        {hasRequiredTrainings && hasChartData && (
         <Paper 
        className={classes.paper}
        >
        <div style={{display:"flex", justifyContent:"space-between"}}>
      <h3 className={classes.chartTitle}>{t('progress_page.volume_chart')}</h3>
      <InfoButton onClick={handleOpenVolumeDialog} style={{marginRight: "20px", marginTop:"20px", height: "24px", width: "24px"}}/>			
					<Dialog
                PaperProps={{
                    style:{
                        border: "2px solid rgba(64, 64, 64, 1)",
                        borderRadius: "20px"
                    }
                }}              
				open={openVolumeDialog} 
				onClose={handleCloseVolumeDialog}				
				>
            <div style={{display: "flex", flexWrap: "wrap", justifyContent: "space-between", borderBottom: "2px solid #404040", alignItems: "center", width: "100%"}}>
			<DialogTitle className={classes.dialogTitle}>{t('progress_page.volume_chart')}</DialogTitle>
			<IconButton  
				onClick={handleCloseVolumeDialog}
				style={{
                    paddingRight: 10,
                    flexShrink: 0, 
                }}>
				<CloseButton />
			</IconButton>
            </div>
			<DialogContent>
				<DialogContentText style={{color: "#404040", fontSize:"0.75rem", lineHeight: "18px", fontWeight: 400, padding: 0, margin: 0}}>
				<p>{t('progress_page.volume_chart_explanation')}</p>
				</DialogContentText>
			</DialogContent>			
			</Dialog>
            </div>
            <div style={{display: 'flex'}}>
  {/* Fixed Y-Axis Chart */}
  <div style={{ width: 60, height: 300 }}>
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart data={displayedData} margin={{ top: 10, left: 0, right: 0, bottom: 0 }}>
        <XAxis dataKey="week" width={0} /> {/* Hide X-axis here */}
        <YAxis           
          tick={{fontSize: 14 }}           
          width={50} 
          domain={['auto', 'auto']}
        />
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="black" />
        <Bar dataKey="volume" fill="transparent" stroke="transparent" /> {/* Invisible */}
      </ComposedChart>
    </ResponsiveContainer>
  </div>

  {/* Scrollable Chart */}
  <div
    ref={volumeChartRef}
    onScroll={handleScroll}
    style={{
      width: '100%',
      overflowX: 'auto',
      overflowY: 'hidden',
      position: 'relative',
      scrollbarWidth: 'thin',      
      WebkitOverflowScrolling: 'touch',
    }}
  >
    <div style={{ width: chartsWidth, minWidth: "100%", position: 'relative' }}>
      <ResponsiveContainer width="100%" height={300}>
        <ComposedChart data={displayedData} margin={{ left: 5, right: 10, top: 5 }}>
          <XAxis
            dataKey={selectedInterval === 'weekly' ? 'week' : 'date'}
            tick={(props) => <CustomTick {...props} selectedInterval={selectedInterval} />}
            domain={displayedData.length === 1 ? ['dataMin - 1', 'dataMax + 1'] : ['auto', 'auto']}
            tickMargin={8}
          />
          <YAxis width={0} />
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="black" />
          {selectedInterval === 'daily' ? (
            <Line type="monotone" dataKey="volume" stroke="rgba(64, 64, 64, 1)" strokeWidth={2} />
          ) : (
            <Bar dataKey="volume" fill="rgba(0, 160, 223, 1)" barSize={itemWidth * 0.8} />
          )}
          <Tooltip content={<CustomToolTip />} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  </div>
</div>
      </Paper>
        )}
    {hasTimeChartData && (
      <Paper
    className={classes.paper}
    
    >
        <div style={{display:"flex", justifyContent:"space-between"}}>
      <h3 className={classes.chartTitle}>{t('progress_page.time_chart')}</h3>
      <InfoButton onClick={handleOpenTimeDialog} style={{marginRight: "20px", marginTop:"20px", height: "24px", width: "24px"}}/>			
					<Dialog 
                PaperProps={{
                    style:{
                        border: "2px solid rgba(64, 64, 64, 1)",
                        borderRadius: "20px"
                    }
                }}
				open={openTimeDialog} 
				onClose={handleCloseTimeDialog}				
				>
            <div style={{display: "flex", flexWrap: "wrap", justifyContent: "space-between", borderBottom: "2px solid #404040", alignItems: "center", width: "100%"}}>
			<DialogTitle className={classes.dialogTitle}>{t('progress_page.time_chart_info_title')}</DialogTitle>
			<IconButton  
				onClick={handleCloseTimeDialog}
				style={{
                    paddingRight: 10,
                    flexShrink: 0,
                }}>
				<CloseButton />
			</IconButton>
            </div>
			<DialogContent>
				<DialogContentText style={{color: "black", fontSize:"0.75rem", lineHeight: "18px", fontWeight: 400, padding: 0, margin: 0}}>
				  <p>{t('progress_page.time_chart_explanation')}</p>
				</DialogContentText>
			</DialogContent>			
			</Dialog>
            </div>
            <div style={{display: 'flex'}}>
                <div style={{width: 60, height: 300}}>
                <ResponsiveContainer width="100%" height="100%">
                    <ComposedChart data={displayedTimeData} margin={{top: 0, left: 0, right: 0, bottom: 0}}>
                        <XAxis dataKey= "week" width={0} />
                        <YAxis
                        tick={{fontSize: 14}}
                        width={50}
                        domain={['auto', 'auto']}
                        />
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="black"/>
                    <Bar dataKey="gymTime" fill="transparent" stroke="transparent"/>                    
                    </ComposedChart>
                </ResponsiveContainer>
                </div>            
            <div
    ref={timeChartRef}    
    onScroll={handleScroll}
    style={{
        width: '100%',
        overflowX: 'auto',
        overflowY: 'hidden',
        position: 'relative',
        scrollbarWidth: 'thin',
        WebkitOverflowScrolling: 'touch',
    }}        
    >
            <div style={{width: chartsWidth, minWidth: "100%", position: 'relative'}}>
            <ResponsiveContainer  height={300} width="100%">
      <ComposedChart
      data={displayedTimeData}
      margin={{left: -25, right: 0}}      
      >
      <XAxis
  dataKey={selectedInterval === 'weekly' ? 'week' : 'date'}
  ticks={displayedTimeData.map(d => d[selectedInterval === 'weekly' ? 'week' : 'date'])}
  tick={(props) => <CustomTick {...props} selectedInterval={selectedInterval} />}                
  tickMargin={6}
  interval={0}
/>

      
      <Tooltip
      content={<CustomTimeTooltip />}          
       />
      
      <CartesianGrid strokeDasharray = "3 3" stroke= "black" vertical={false} />
       <Bar dataKey="gymTime" name={t('common.gym_visit')} fill="#46A9DB" barSize={20} />           
       <Bar dataKey="homeTime" name={t('common.home_workout')} fill="#F28986" barSize={20} />   
       <YAxis
       width={0}
       />
      </ComposedChart>
      </ResponsiveContainer>
      </div>
      </div>
      </div>
      </Paper>
        )}
      </div>            
  );
}

